(function () {

  'use strict';

  angular.module('Support')

    .constant('TICKET_PRIORITY', [
      { id: 'NORMAL', name: '-' },
      { id: 'LOW', name: 'Low' },
      { id: 'NORMAL', name: 'Normal' },
      { id: 'HIGH', name: 'High' },
      { id: 'URGENT', name: 'Urgent' }
    ])

    .constant('TICKET_PRODUCT', [
      { id: 'PRINTIX', name: 'Printix' },
      { id: 'POWER_PDF', name: 'Power PDF' }
    ])

    .controller('SupportController', function (
      $filter, $location, $rootScope, $scope, URLS, APIAdmin, TenantListService,
      focus, toastr, EventHandlerService, TICKET_PRIORITY, TICKET_PRODUCT, CopilotService) {

      $scope.supportTicket = {
        email: '',
        subject: '',
        description: '',
        phoneNumber: '',
        ticketProduct: 'PRINTIX',
        ticketPriority: 'NORMAL'
      };

      $scope.supportTicketSubjectFocusKey = 'supportTicketSubjectFocusKey';
      $scope.helpCaption = 'HelpSupportPage';

      $scope.priority = {
        listRaw: TICKET_PRIORITY,
        skipOrderByName: true
      };

      $scope.product = {
        listRaw: [],
        skipOrderByName: true
      };

      $scope.priorityDefault = $scope.priority.listRaw[0];
      $scope.productDefault = undefined;

      (function () {
        EventHandlerService.deRegisterListeners();
        setupProductList();
        fulfillCopilotRequest();
      })();

      function setupProductList() {
        if (TenantListService.currentTenant.isPrintixEnabled()) {
          const product = TICKET_PRODUCT.find(product => product.id === 'PRINTIX');
          if (product) {
            $scope.product.listRaw.push(product);
          }
        }
        if (TenantListService.currentTenant.isPowerPDFEnabled()) {
          const product = TICKET_PRODUCT.find(product => product.id === 'POWER_PDF');
          if (product) {
            $scope.product.listRaw.push(product);
          }
        }
        $scope.productDefault = $scope.product.listRaw[0];
        $scope.supportTicket.ticketProduct = $scope.productDefault?.id;
      }

      function fulfillCopilotRequest() {
        const copilotParameters = CopilotService.useSupportParameters();
        if (copilotParameters.subject) {
          $scope.supportTicket.subject = copilotParameters.subject;
        }
        if (copilotParameters.description) {
          $scope.supportTicket.description = copilotParameters.description;
        }
        if (copilotParameters.ticketPriority) {
          const copilotDefault = TICKET_PRIORITY.find(function (priority) {
            return priority.id === copilotParameters.ticketPriority;
          });
          if (copilotDefault) {
            $scope.priorityDefault = copilotDefault;
            $scope.supportTicket.ticketPriority = copilotDefault;
          }
        }
        if (copilotParameters.ticketProduct) {
          const copilotDefault = $scope.product.listRaw.find(function (product) {
            return product.id === copilotParameters.ticketProduct;
          });
          if (copilotDefault) {
            $scope.productDefault = copilotDefault;
            $scope.supportTicket.ticketProduct = copilotDefault;
          }
        }
      }

      $scope.sendSupportTicket = function (form, event) {
        if (form && event) {
          if (form.$invalid) {
            event.preventDefault();
          } else {
            const objectToSend = angular.copy($scope.supportTicket);
            if (!objectToSend.phoneNumber) {
              delete objectToSend.phoneNumber;
            }
            if (objectToSend.ticketProduct.id) {
              objectToSend.ticketProduct = objectToSend.ticketProduct.id;
            }
            if (objectToSend.ticketPriority.id) {
              objectToSend.ticketPriority = objectToSend.ticketPriority.id;
            }
            if (objectToSend.email === $rootScope.currentUser.info._embedded.user.email) {
              delete objectToSend.email;
            }
            $scope.waitingForAnswer = true;
            APIAdmin.addSupportTicket(TenantListService.currentTenant.info._links['px:csOpenTicket'].href, objectToSend)
              .then(function () {
                $scope.waitingForAnswer = false;
                form.$setPristine();
                $location.path(URLS.HOME);
                toastr.success($filter('translate')('EmailSent'));
              })
              .catch(function () {
                $scope.waitingForAnswer = false;
              });
          }
        } else {
          throw new Error('$scope.sendSupportTicket: form or event are missing');
        }
      };

      $scope.setPriority = function (priority) {
        $scope.supportTicket.ticketPriority = priority.id;
      };

      $scope.setProduct = function (product) {
        $scope.supportTicket.ticketProduct = product.id;
      };

      const deregisterWatchCurrentUser = $scope.$watch(function () {
        return $rootScope.currentUser;
      }, function () {
        if ($rootScope.currentUser) {
          deregisterWatchCurrentUser();
          $scope.supportTicket.email = $rootScope.currentUser.info._embedded.user.email;
          focus($scope.supportTicketSubjectFocusKey);
        }
      });

    });

})();
